import React from "react";
import ContactFormSection from "./ContactFormSection";

const MapSection: React.FC = () => {
  return (
    <section className="py-20 bg-white dark:bg-slate-900">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#212026] dark:text-white mb-4">
            Send Us a Message
          </h2>
          <p className="text-xl text-[#889d8f] dark:text-[#dbcfbf]">
            Ready to discuss your project? Fill out the form below and we'll get
            back to you within 24 hours.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="h-full bg-[#dbcfbf]/20 dark:bg-slate-800 rounded-lg overflow-hidden shadow-lg border dark:border-slate-700">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3074.7664586217193!2d-104.88575542422572!3d39.58741350569682!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x876c85d703da7c99%3A0x3e6b380c8f47dec0!2s7108%20S%20Alton%20Way%2C%20Centennial%2C%20CO%2080112%2C%20USA!5e0!3m2!1sen!2sin!4v1758888975513!5m2!1sen!2sin"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location Map"
            ></iframe>
          </div>
          <div className="space-y-6">
            <ContactFormSection />
            {/* <div className="bg-[#e18033]/5 dark:bg-[#e18033]/10 border border-[#e18033]/20 dark:border-[#e18033]/30 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-[#212026] dark:text-white mb-3">Schedule a Visit</h3>
              <p className="text-[#889d8f] dark:text-[#dbcfbf] mb-4">
                Want to discuss your project in person? Schedule a consultation at our office.
              </p>
              <button className="bg-[#e18033] hover:bg-[#d16f29] text-white font-semibold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl">
                <i className="ri-calendar-line mr-2"></i>
                Book Consultation
              </button>
            </div> */}
          </div>
        </div>
        <div className="mt-16 bg-white rounded-lg p-8 shadow-lg">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Business Hours
              </h3>
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-gray-600">Monday - Friday</span>
                  <span className="font-semibold text-gray-900">
                    9:00 AM - 6:00 PM
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Saturday</span>
                  <span className="font-semibold text-gray-900">
                    10:00 AM - 4:00 PM
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Sunday</span>
                  <span className="font-semibold text-gray-900">Closed</span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Response Times
              </h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-time-line text-orange-500 mr-3"></i>
                  <span className="text-gray-700">
                    Email inquiries: Within 24 hours
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="ri-phone-line text-orange-500 mr-3"></i>
                  <span className="text-gray-700">
                    Phone calls: Immediate during business hours
                  </span>
                </div>
                <div className="flex items-center">
                  <i className="ri-file-text-line text-orange-500 mr-3"></i>
                  <span className="text-gray-700">
                    Quote requests: Within 48 hours
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
